import axios from "axios";

// Centralized API configuration
export const API_BASE_URL = "https://velan-system.online/api";

// Create an axios instance with the base URL
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

// Function to get the full API URL for a specific endpoint
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Add a request interceptor to handle authentication tokens
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sessionToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for centralized error handling
apiClient.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx will trigger this function
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx will trigger this function
    if (error.response) {
      // Server responded with a status code outside of 2xx
      console.error(`API Error (${error.response.status}):`, error.response.data);
    } else if (error.request) {
      // Request was made but no response received
      console.error('API Error: No response received', error.request);
    } else {
      // Something happened in setting up the request
      console.error('API Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// API helper functions
export const API_BASEURL = async () => {
  try {
    const res = await apiClient.get('/');
    return res.data;
  } catch (error) {
    console.error("Error fetching API base data:", error);
    throw error;
  }
};

export const fetchAnalyticsData = async () => {
  try {
    const res = await apiClient.get('/reports');
    return res.data;
  } catch (error) {
    console.error("Error fetching analytics data:", error);
    throw error;
    throw error;
  }
};
